"use client";

import { ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TechnologyPillars() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    title: "Nghiên cứu & Đổi mới",
    description: "Nghiên cứu tiên tiến trong công nghệ xây dựng, tận dụng chuyên môn từ Trường Đại học Kiến trúc Dân dụng để phát triển các giải pháp bền vững và hiệu quả."
  }, {
    number: "02",
    title: "Chuyển giao Công nghệ",
    description: "Tích hợp liền mạch các giải pháp kỹ thuật tiên tiến vào các dự án xây dựng thực tế, đảm bảo đổi mới đáp ứng ứng dụng thực tiễn."
  }, {
    number: "03",
    title: "Chuyển đổi Số",
    description: "Dịch vụ tư vấn toàn diện để hiện đại hoá quy trình xây dựng, tối ưu hoá luồng công việc và triển khai các công nghệ xây dựng thông minh."
  }];
  return <section id="trụ-cột-công-nghệ" ref={sectionRef} className="dark bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-t border-primary/20">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,var(--color-primary)/0.15,transparent_70%)] pointer-events-none" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent to-transparent opacity-50" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className={`text-center mb-16 transition-all duration-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-primary">
            Trụ Cột Công Nghệ
          </h2>
          <p className="text-muted-foreground text-lg max-w-3xl mx-auto">
            Ba trụ cột nền tảng thúc đẩy đổi mới và xuất sắc trong công nghệ xây dựng
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, i) => {
          const {
            ref: cardRef,
            isVisible: cardVisible
          } = useRevealOnScroll({
            once: true,
            threshold: 0.2
          });
          return <div key={i} data-index={i} ref={cardRef} className={`transition-all duration-700 ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="group h-full border-2 border-border bg-card hover:border-primary hover:shadow-[0_0_20px_rgba(0,190,240,0.3)] transition-all duration-300 relative overflow-hidden">
                  <CardHeader className="pb-4">
                    <div className="text-8xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-br from-primary to-primary/50 opacity-20 group-hover:opacity-40 transition-opacity duration-300">
                      {pillar.number}
                    </div>
                    <CardTitle className="text-2xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-6">
                    <p className="text-muted-foreground leading-relaxed">
                      {pillar.description}
                    </p>
                    <div className="overflow-hidden">
                      <div className="transform translate-x-[-100%] opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-300">
                        <Button variant="ghost" className="text-primary hover:bg-primary/10 p-0 h-auto" asChild>
                          <Link to="#" className="flex items-center gap-2">
                            <span className="font-semibold">Tìm hiểu thêm</span>
                            <ArrowRight className="size-4" />
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}